<div class="page-section flex-percent flex-wrapper">
    <div class="container-67 flex-column container">
        <live-tag-details [tags]="tags$ | async"> </live-tag-details>
        <percent-selector [value]="newPercents$ | async" (valueChanged)="newPercents$.next($event)"></percent-selector>
        <mat-card>
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="tab-text">PSD Timeline</div>
                    </ng-template>
                    <div class="tab-content">
                        <ng-container>
                            <div class="flex-row justify full-width feature-btn-container">
                                <div class="button-group left-group flex-row top">
                                    <button mat-mini-fab color="primary" class="control-line-button"
                                        *ngIf="timelineChartType === 'default' && (user$ | async)?.permissions >= 1" [disabled]="!(device$ | async)"
                                        [matMenuTriggerFor]="addToChartMenu" aria-label="Add to chart" matTooltip="Add to chart" matTooltipPosition="below">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                    <mat-menu #addToChartMenu="matMenu" class="chart-add-menu" xPosition="after" yPosition="below" [overlapTrigger]="false">
                                        <div class="chart-add-menu-title" (click)="$event.stopPropagation()">
                                            Add to chart
                                        </div>
                                        <button mat-menu-item class="chart-add-menu-item" (click)="openControlLines()">
                                            <mat-icon>more_horiz</mat-icon>
                                            <span class="chart-add-menu-copy">
                                                <span>Control Line</span>
                                                <span class="chart-add-menu-description">
                                                    Horizontal reference at a fixed value
                                                </span>
                                            </span>
                                        </button>
                                    </mat-menu>
                                    <timeline-chunk-selector [selectedTimeLineChunk]="selectedTimelineChunk$ | async"
                                        (timeLineChunkChanged)="setTimeLineChunk($event)"
                                        [timeLineChunks]="timeLineChunks">
                                    </timeline-chunk-selector>
                                    <ng-container
                                        *ngIf="timelineChartType === 'custom' && (customTimelineChartLines$ | async)?.series?.length">
                                        <mat-icon *ngIf="timelineChartType === 'custom'"
                                            (click)="openCustomSizerangeDialog()" matTooltip="Set Custom Sizes"
                                            [matTooltipPosition]="'below'" class="custom-sizes-btn">launch</mat-icon>

                                        <button mat-button class="scondary-toggle-button"
                                            [class.active]="customTimelineChartType === 'size'"
                                            (click)="customTimelineChartType = 'size'">Size</button>
                                        <button mat-button class="scondary-toggle-button"
                                            [class.active]="customTimelineChartType === 'range'"
                                            (click)="customTimelineChartType = 'range'">Range</button>
                                    </ng-container>
                                </div>

                                <div class="button-group right-group flex-row end">
                                    <button mat-button class="scondary-toggle-button"
                                        [class.active]="timelineChartType === 'default'"
                                        (click)="timelineChartType = 'default'"> D Values</button>
                                    <button mat-button class="scondary-toggle-button"
                                        [class.active]="timelineChartType === 'custom'"
                                        (click)="timelineChartType = 'custom'"> Custom Sizes</button>
                                    <button mat-button class="scondary-toggle-button"
                                        [class.active]="timelineChartType === 'oversizeRock'"
                                        (click)="timelineChartType = 'oversizeRock'">Oversize Rock</button>
                                </div>
                            </div>

                            <div *ngIf="(chartLines$ | async) === undefined" class="container centered-content">
                                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                            </div>
                            <div *ngIf="(this.fragQuery.addOnTimelineSieveSizesAtPercents$|async)===undefined"
                                class="container centered-content add-on-loader">
                                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                            </div>

                            <div *ngIf="(chartLines$ | async) === null" class="container centered-content">
                                <div class="container centered-content">
                                    <div>
                                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                    </div>
                                    <div>No Data Found</div>
                                </div>
                            </div>
                            <div *ngIf="timelineChartType === 'default'">
                                <div *ngIf="(chartType$ | async) === 'line'">
                                    <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="chartLines$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                                <div *ngIf="(chartType$ | async) === 'series'">
                                    <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="chartSeries$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                            </div>
                            <div *ngIf="timelineChartType === 'oversizeRock'">
                                <div *ngIf="(chartType$ | async) === 'line'">
                                    <figure *ngIf="(oversizeRockChartLines$ | async)"
                                        class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="oversizeRockChartLines$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                                <div *ngIf="(chartType$ | async) === 'series'">
                                    <figure *ngIf="(oversizeRockChartSeries$ | async)"
                                        class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="oversizeRockChartSeries$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                            </div>
                            <div *ngIf="timelineChartType === 'custom'">
                                <div *ngIf="customTimelineChartType === 'size'">
                                    <!-- No Data Found for Size -->
                                    <div *ngIf="(customTimelineChartLines$ | async)?.series?.length === 0"
                                        class="container centered-content">
                                        <div class="container centered-content">
                                            <div>
                                                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                            </div>
                                            <div>Please Set Custom size first to view the chart
                                                <button *ngIf="timelineChartType === 'custom'" mat-icon-button
                                                    (click)="openCustomSizerangeDialog()" matTooltip="Set Custom Sizes"
                                                    [matTooltipPosition]="'below'">
                                                    <mat-icon>launch</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="(customTimelineChartLines$ | async)?.series?.length">
                                        <div *ngIf="(chartType$ | async) === 'line'">
                                            <figure *ngIf="customTimelineChartLines$ | async"
                                                class="highcharts-figure full-width">
                                                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                                    [constructorType]="'stockChart'"
                                                    [options]="customTimelineChartLines$ | async">
                                                </highcharts-chart>
                                            </figure>
                                        </div>
                                        <div *ngIf="(chartType$ | async) === 'series'">
                                            <figure *ngIf="customTimelineChartSeries$ | async"
                                                class="highcharts-figure full-width">
                                                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                                    [constructorType]="'stockChart'"
                                                    [options]="customTimelineChartSeries$ | async">
                                                </highcharts-chart>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="customTimelineChartType === 'range'">
                                    <!-- No Data Found for Range -->
                                    <div *ngIf="!(customRangeTimelineChartLines$ | async)?.series?.length"
                                        class="container centered-content">
                                        <div class="container centered-content">
                                            <div>
                                                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                            </div>
                                            <div>No Data Found</div>
                                        </div>
                                    </div>
                                    <div *ngIf="(customRangeTimelineChartLines$ | async)?.series?.length">
                                        <div *ngIf="(chartType$ | async) === 'line'">
                                            <figure *ngIf="customRangeTimelineChartLines$ | async"
                                                class="highcharts-figure full-width">
                                                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                                    [constructorType]="'stockChart'"
                                                    [options]="customRangeTimelineChartLines$ | async">
                                                </highcharts-chart>
                                            </figure>
                                        </div>
                                        <div *ngIf="(chartType$ | async) === 'series'">
                                            <figure *ngIf="customRangeTimelineChartSeries$ | async"
                                                class="highcharts-figure full-width">
                                                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                                    [constructorType]="'stockChart'"
                                                    [options]="customRangeTimelineChartSeries$ | async">
                                                </highcharts-chart>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="tab-text">Quantity Timeline</div>
                    </ng-template>
                    <div class="tab-content">
                        <ng-container>
                            <div class="flex-row justify full-width feature-btn-container">
                                <timeline-chunk-selector [selectedTimeLineChunk]="selectedTimelineChunk$ | async"
                                    (timeLineChunkChanged)="setTimeLineChunk($event)" [timeLineChunks]="timeLineChunks">
                                </timeline-chunk-selector>
                                <div class="button-group left-group flex-row top left-group">
                                    <span class="density-container"
                                        *ngIf="quantityChartType === 'payload' && (weightType$|async) === 'volume'">
                                        <b>Density: </b>
                                        <span>
                                            <ng-container *ngIf="device$ | async as device">
                                                <measurement type="largeDensity"
                                                    [unitSystem]="(quantityUnitSystem$ | async)"
                                                    [value]="device.density">
                                                </measurement>
                                            </ng-container>
                                        </span>
                                    </span>
                                </div>

                                <div class="button-group right-group flex-row end right-group">
                                    <button mat-button class="scondary-toggle-button"
                                        [class.active]="quantityChartType === 'volume'"
                                        (click)="quantityChartType = 'volume'">Volume</button>

                                    <button mat-button class="scondary-toggle-button"
                                        [class.active]="quantityChartType === 'payload'"
                                        (click)="quantityChartType = 'payload'">Payload</button>
                                </div>
                            </div>

                            <div *ngIf="(chartLines$ | async) === undefined" class="container centered-content">
                                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                            </div>
                            <div *ngIf="(this.fragQuery.addOnTimelineSieveSizesAtPercents$|async)===undefined"
                                class="container centered-content add-on-loader">
                                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                            </div>
                            <div *ngIf="(chartLines$ | async) === null" class="container centered-content">
                                <div class="container centered-content">
                                    <div>
                                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                    </div>
                                    <div>No Data Found</div>
                                </div>
                            </div>
                            <div *ngIf="quantityChartType === 'volume'">
                                <div *ngIf="(chartType$ | async) === 'line'">
                                    <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="quantityChartLines$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                                <div *ngIf="(chartType$ | async) === 'series'">
                                    <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="quantityChartSeries$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                            </div>
                            <div *ngIf="quantityChartType === 'payload'">
                                <div *ngIf="(chartType$ | async) === 'series'">
                                    <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="payloadChartSeries$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                                <div *ngIf="(chartType$ | async) === 'line'">
                                    <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                                        <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                                            [constructorType]="'stockChart'" [options]="payloadChartLines$|async">
                                        </highcharts-chart>
                                    </figure>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
    <div class="container-33 container">
        <snapshot-card-analysis>
        </snapshot-card-analysis>
    </div>
</div>